import RemoveRepository from "@domain/repositories/RemoveRepository";
import UseCase from "@domain/UseCase";
import { RemoveHistory } from "@domain/models/RemoveHistory";
import { RemoveJob } from "@domain/models/RemoveJob";

type Input = RemoveHistory["id"];

type Output = Promise<RemoveJob>;

export class UndoRemoveClientsUseCase implements UseCase<Input, Output> {
  constructor(private readonly removeRepository: RemoveRepository) {}

  execute(removeHistoryId: Input) {
    return this.removeRepository.undoRemoveClients(removeHistoryId);
  }
}
